import React, { useState, useEffect } from "react";
import AuthSwitch from "@/components/AuthSwitch";
import GitHub from "@/assets/Github.svg";
import { login, register } from "@/services/auth";
import { useNavigate } from "react-router-dom";
import { profilePictures } from "@/lib/data";
import useUserData from "@/hooks/useUserData";
import { API_URL } from "@/env";
import EyeClosed from "@/assets/icons/EyeClosed.svg";
import Eye from "@/assets/icons/Eye.svg";
import LoadingBlack from "@/assets/icons/LoadingBlack.svg";
import { motion, AnimatePresence } from "motion/react";

const validateEmail = (email: string) => {
  // Very basic email validation. Adjust as needed.
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.toLowerCase());
};

const ResetPassword = () => {
  // Login form
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    // Basic validations
    if (!email) {
      setError("Email is required.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/auth/request-reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
        }),
      });

      const data = await res.json();

      // console.log({ data }, data.status);

      if (data.status === "success") {
        setError("");
        setMessage(data.message);
      } else {
        setError(data.error);
        setMessage("");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      }}
      onSubmit={handleSubmit}
      className="w-[400px] text-white bg-black/[0.8] rounded-[35px] backdrop-blur-[40px] p-[1px]"
    >
      <div className="border-[0.5px] border-white/[0.35] rounded-[34px] w-full h-full pt-[30px] px-[20px] pb-[25px]">
        <div className="w-[250px] text-center mx-auto">
          <p className="onest-smb text-[20px] leading-[25.5px]">
            Reset Your Password
          </p>
          <p className="onest-md text-[14px] leading-[21px] mt-[6px] text-white/[0.35]">
            Enter your email to receive password reset instructions.
          </p>
        </div>

        <div className="mt-[25px]">
          <>
            <div className="flex flex-col gap-[6px] w-full mt-[12px]">
              <label
                className="text-[14px] onest-md leading-[17.85px] text-white/[0.35] pl-[15px]"
                htmlFor="email_login"
              >
                Email
              </label>
              <input
                id="email_login"
                type="email"
                className="px-[15px] onest-md h-[37px] bg-white/[0.05] text-white rounded-[15px] border-[0.5px] border-white/[0.1]"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Display login error if any */}
            {error && <p className="text-red-400 mt-2 text-sm">{error}</p>}
            {message && (
              <p className="text-white leading-[150%] mt-[20px] px-[15px] text-[12px] text-center">
                {message}
              </p>
            )}

            <button className="w-full onest-smb mt-[25px] bg-white text-black h-[38px] flex items-center justify-center rounded-[15px] text-[14px]">
              {!loading && "Reset"}
              {/* <AnimatePresence> */}
              {loading && (
                <motion.img
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="animate-spin"
                  src={LoadingBlack}
                />
              )}
              {/* </AnimatePresence> */}
            </button>
          </>
        </div>
      </div>
    </form>
  );
};

export default ResetPassword;
